var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisputeAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.367 10.586h1.02l-.833 3.021a.367.367 0 0 0 .64.326l3.86-4.841a.366.366 0 0 0-.287-.596h-1.335l.828-1.988A.366.366 0 0 0 10.922 6h-1.73a.367.367 0 0 0-.332.21l-1.825 3.852a.367.367 0 0 0 .332.524zm2.057-3.852h.948l-.828 1.988a.367.367 0 0 0 .338.508h1.123l-2.269 2.846.485-1.76a.367.367 0 0 0-.353-.464h-.922l1.478-3.118z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.527 8.201h-3.885c.045.058.084.12.117.185a1.106 1.106 0 0 1-.132 1.163l-.388.487H14.7a.367.367 0 0 1 0 .734h-3.046l-.585.733H14.7a.367.367 0 0 1 0 .734h-4.216l-.585.734h4.802a.367.367 0 0 1 0 .733H9.314l-.547.686a1.095 1.095 0 0 1-.862.414 1.1 1.1 0 0 1-.353-.06H7.55v1.573a.777.777 0 0 0 .122.446c.215.315.62.29.898.078l2.02-1.302h5.76c.514 0 1.1-.586 1.1-1.1V9.141a.933.933 0 0 0-.924-.94z",
    fill: "#fff",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24,
    y1: 0,
    x2: -0.598,
    y2: 0.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FCB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DE995"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeAction);
export default __webpack_public_path__ + "static/media/disputeAction.3602d9baa474d50e345b6c5c7710d534.svg";
export { ForwardRef as ReactComponent };